import { useEffect, useState } from 'react';

import { ModalLayoutComponent } from '@workinance/shared/ui/ModalLayoutComponent';
import { WifiOffIcon } from '@workinance/shared/ui/icons';

/**
 * Mount once near an app's root, beside AlertComponent. Shows a non-dismissible notice the moment
 * the browser goes offline, and removes it on its own the moment the connection returns -- there is
 * nothing for the person to click either way.
 */
export function OfflineStatusComponent() {
	const [isOffline, setIsOffline] = useState(
		typeof navigator !== 'undefined' && !navigator.onLine,
	);

	useEffect(() => {
		const handleOffline = () => setIsOffline(true);
		const handleOnline = () => setIsOffline(false);
		window.addEventListener('offline', handleOffline);
		window.addEventListener('online', handleOnline);
		return () => {
			window.removeEventListener('offline', handleOffline);
			window.removeEventListener('online', handleOnline);
		};
	}, []);

	return (
		<ModalLayoutComponent
			isOpen={isOffline}
			onClose={() => {}}
			isDismissible={false}
			showCloseButton={false}
			size="md"
			title="You're offline"
			description="Check your internet connection. This will close on its own once you're back online."
		>
			<span className="relative mx-auto grid size-20 place-items-center rounded-full bg-warn-soft text-warn">
				<span className="absolute inset-0 rounded-full bg-warn-soft motion-safe:animate-ping" />
				<WifiOffIcon className="relative size-9" />
			</span>
		</ModalLayoutComponent>
	);
}
